import React from 'react';
import './Dropdown.css';

const Dropdown = ({ label, id, name, value, onChange, options, disabled, className, error }) => {
  const inputClassName = `dropdown-select ${className || ''} ${error ? 'input--error' : ''}`;

  return (
    <div className="dropdown-field">
      {label && <label htmlFor={id}>{label}</label>}
      <select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={inputClassName}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <span className="dropdown-field-error">{error}</span>}
    </div>
  );
};

export default Dropdown;
